import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmbeddedNewpasswordPage } from './embedded-newpassword.page';

const routes: Routes = [
  {
    path: '',
    component: EmbeddedNewpasswordPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmbeddedNewpasswordPageRoutingModule {}
